import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AdmissionsOpen() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [admissionPosts, setAdmissionPosts] = useState([]);

  useEffect(() => {
    // Simulate API fetch
    const timer = setTimeout(() => {
      setAdmissionPosts([
        {
          id: 1,
          college: "GL Mehta College of Training",
          title: "Annual College Fest",
          description: "Join us on March 15, 2025 for music, dance, and unlimited fun fest! Various competitions and workshops available.",
          image: "assets/imageu.png"
        },
        {
          id: 2,
          college: "Science & Technology Institute",
          title: "New Course Admissions",
          description: "Applications now open for our new AI and Data Science programs. Limited seats available for 2025 batch.",
          image: "assets/imageu.png"
        }
      ]);
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Skeleton Loader Component
  const AdmissionSkeleton = () => (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-stone-200">
      <div className="flex p-4">
        <div className="w-20 h-20 rounded-lg bg-stone-200 animate-pulse"></div>
        <div className="ml-4 flex-1 space-y-2">
          <div className="h-4 w-3/4 bg-stone-200 rounded animate-pulse"></div>
          <div className="h-3 w-1/2 bg-stone-200 rounded animate-pulse"></div>
          <div className="h-3 w-full bg-stone-200 rounded animate-pulse"></div>
          <div className="h-3 w-4/5 bg-stone-200 rounded animate-pulse"></div>
          <div className="h-4 w-20 bg-stone-200 rounded animate-pulse mt-3"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-stone-700 px-2">Admissions Open</h2>

      {loading ? (
        <>
          <AdmissionSkeleton />
          <AdmissionSkeleton />
        </>
      ) : (
        <>
          {admissionPosts.map(post => (
            <div
              key={post.id}
              className="bg-white rounded-xl shadow-sm overflow-hidden border border-stone-200 hover:shadow-md transition-shadow"
            >
              <div className="flex p-4">
                <img
                  src={post.image}
                  alt="College"
                  className="w-20 h-20 rounded-lg object-cover border border-stone-200"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "assets/default-college.png";
                  }}
                />
                <div className="ml-4 flex-1">
                  <h3 className="font-semibold text-stone-800">{post.college}</h3>
                  <p className="text-sm text-stone-600 mt-1 line-clamp-1">
                    {post.title}
                  </p>
                  <p className="text-xs text-stone-500 mt-1 line-clamp-2">
                    {post.description}
                  </p>
                  <button
                    onClick={() => navigate("/courses")}
                    className="mt-3 text-amber-600 text-sm font-medium flex items-center hover:text-amber-700 transition-colors"
                  >
                    Apply Now
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </>
      )}

      <button
        onClick={() => navigate("/courses")}
        className={`w-full py-2 text-amber-600 rounded-lg text-sm font-medium transition-colors ${
          loading ? "bg-stone-200 animate-pulse h-10" : "bg-amber-50 hover:bg-amber-100 border border-amber-200"
        }`}
        disabled={loading}
      >
        {loading ? "" : "View All Admissions"}
      </button>
    </div>
  );
}

export default AdmissionsOpen;